import React from "react";
import { Button, Modal } from 'react-bootstrap';
import styles from '../../../styles/FarmGlobal/TesteDeBase.module.scss';
import { useFGMateriaisComposicao } from "../../../contexts/FarmGlobal/MateriaisComposicaoContext";

const ModalConfirmacao = () => {

    const { showConfirmacaoEdit, setShowConfirmacaoEdit, materialAtivo, handleSaveUpdateMaterial } = useFGMateriaisComposicao();

    return (
        <Modal
            show={showConfirmacaoEdit}
            onHide={()=> { setShowConfirmacaoEdit(false);}}
            backdrop="static"
            keyboard={false}
            centered
        >
        <Modal.Header>
            <Modal.Title>Confirmação de Solicitação</Modal.Title>
        </Modal.Header>
        <Modal.Body  style={{textAlign:'center'}}>
            <span>              
                Tem certeza que deseja seguir com a atualização do material  <br/><strong>{materialAtivo?.Descricao}</strong>?                
            </span>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
            <Button
                    variant="success"
                    className={styles.modalBtn}
                    onClick={handleSaveUpdateMaterial}
                >
                    Sim
                </Button>
                <Button
                    variant="outline-danger"
                    className={styles.modalBtn}
                    onClick={()=> { setShowConfirmacaoEdit(false);}}
                >
                    Voltar
                </Button>
        </Modal.Footer>
      </Modal>
    ) 
}

export default ModalConfirmacao;
